import { pendoApiKey, environment } from "../config"; 

class Telemetry {

    identifyPendoUser(userId, userData = {}, accountData = {}) {
        if (!window.pendo) return;

        window.pendo.identify({
            visitor: {
                id: userId,
                ...userData
            },
            account: {
                id: `${accountData.countryCode}_${accountData.districtState}_${accountData.districtName}`.replaceAll(/\s/g,''),
                environment: `ROI_${environment}`,
                ...accountData
            }
        });
    }

    initializePendo() {
        if (window.pendo) return;

        // provided by Pendo
        (function(apiKey) {
            (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
            v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
                o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));}
            })(v[w]);
            y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
            z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
        
            window.pendo.initialize({
                visitor: {
                    id: 'VISITOR-UNIQUE-ID' // called before user is identified
                },
            })
        })(pendoApiKey);

        // Custom code to reinitialize user in case of browser refresh.
        const user = null !== localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
        if (user) {
            this.identifyPendoUser(
                user["id"],
                {
                    userEmail: user['email'],
                    userRole: user['role'],
                },
                {
                    districtId: user['districtId'],
                    districtName: user['districtName'],
                    districtState: user['districtState'],
                    countryCode: user['countryCode'],
                    schoolId: user['schoolId'],
                    schoolIds: user['schoolIds'],
                    schoolNames: user['schoolNames']
                }
            )
        }
    }
}

const telemetry = new Telemetry();
telemetry.initializePendo();
export default telemetry;

